export const COPY_SELECTED_VALUE = 'Click to copy';